<header>
  <div class="d-flex align-items-center justify-content-between loginheader">

    <div class="py-3 d-flex align-items-center">
      <button (click)="menuToggle.emit()" class="btn-burger">
        <i class="fa fa-bars"></i>
      </button>
      <a href="https://testmssidcweb.mahaitgov.in/"><img alt="MSSIDC Logo" class="MSSIDC-logo" src="assets/Images/MSSIDC_logo.png"></a>
      <!--<img alt="MSSIDC Logo" class="MSSIDC-logo" src="assets/Images/MSSIDC_logo.png">-->

      <div class="logoText ps-3">
        <p class="header-h1">Maharashtra Small Scale Industries Development Corporation Ltd.</p>

        <p class="header-h2">A Government Of Maharashtra Undertaking <small>CIN No. U74999MH1962SGC012501</small></p>
      </div>
    </div>

    <div class="d-flex">
      <a href="https://www.maharashtra.gov.in/" target="_blank" data-bs-toggle="modal" data-bs-target="#gotowebsite">
        <img alt="" class="maha-logo" src="assets/Images/Maharashtra-Gov-Logo.png">
      </a>
      <a href="https://www.india.gov.in/" target="_blank" data-bs-toggle="modal" data-bs-target="#gotowebsite">
        <img alt="" class="emblem-logo" src="assets/Images/national_emblem_white.svg">
      </a>
    </div>


  </div>
  <div class="px-2 pb-1 manual-container">
    <!--Show IA Manual if userType is 'IA' or 'mssidc'-->
    <a *ngIf="normalizedUserType === 'ia' || normalizedUserType === 'mssidc'"
       (click)="openIAUserManual()"
       class="manual-link">
      <b>IA User Manual</b>
    </a>
    <!--Show MSME Manual if userType is 'MSME' or 'mssidc'-->
    <a *ngIf="normalizedUserType === 'msme' || normalizedUserType === 'mssidc'"
       (click)="openMSMEUserManual()"
       class="manual-link">
      <b>MSME User Manual</b>
    </a>

    <b class="welcome-text">Welcome {{ userType }} User</b>

    <div class="px-2 pb-1" style="background-color: #cd1f26;" *ngIf="!isProfileCompleted && isMSMEUser">
      <b class="text-white">Please complete <a [routerLink]="'/otheruserdetails'" class="text-white" title="PROFILE QUESTIONS">PROFILE QUESTIONS </a></b>
    </div>
  </div>

</header>

